module.exports = __webpack_public_path__ + "static/media/mision.430440fa.jpg";